import React, {useEffect} from 'react';
import {Box, Button, TextField} from "@mui/material";
import {Add} from "@mui/icons-material";
import {trash} from "../../../../../../../../icon/trash";
import {copy} from "../../../../../../../../icon/copy";
import {StepData} from "./ChapterTaskDrawer";
import {editTask} from "../../../../../../../../icon/editTask";
import * as Yup from "yup";
import {ErrorMessage, Field, FieldArray, Form, Formik} from "formik";


type StepThreeProps = {
    data: StepData;
    onDataChange: (data: Partial<StepData>) => void;
    handleSave: (data: any) => void;
    close: () => void;
};

const validationSchema = Yup.object({
    questions: Yup.array()
        .required('Необходим хотя бы один вопрос')
        .of(
        Yup.object().shape({
            question: Yup.string().required('Требуется вопрос'),
            answer: Yup.string().required('Требуется ответ'),
        })
    ).min(1, 'Необходим хотя бы один вопрос'),
});

const StepThreeTask: React.FC<StepThreeProps> = ({data, onDataChange, handleSave, close }) => {
    useEffect(() => {
        if (!data.step3.questions.length) {
            onDataChange({step3: {questions: [{question: '', answer: '', isLocked: false}]}});
        }
    }, [onDataChange, data.step3.questions.length]);

    return (
        <div>
            <Formik
                key={data.step3.questions.length}
                initialValues={{questions: data.step3.questions.length ? data.step3.questions : [{question: '', answer: '', isLocked: false}]}}
                validationSchema={validationSchema}
                onSubmit={(values, {setSubmitting}) => {
                    onDataChange({step3: {questions: values.questions}});
                    handleSave({
                        exercise_name: data.step1.name,
                        description: data.step1.taskDescription,
                        file: data.step2.resources,
                        instructions: data.step2.instructions,
                        questions: values.questions.map(q => ({
                            question: q.question,
                            answer: q.answer
                        })),
                        video: data.step2.video,
                        file_name: data.step2.file_name,
                        file_extension: data.step2.file_extension
                    });
                    close();
                }}
            >
                {({values, handleChange, handleBlur, setFieldValue, errors, touched }) => (
                    <Form>
                        <FieldArray name="questions">
                            {({ insert, remove, push }) => (
                                <div>
                                    <div className="step-three-subtitle">
                                        Вы можете добавить до 12 вопросов. Опишите подробно правильные ответы, чтобы
                                        студент смог
                                        сверить их со своими по окончанию задания.
                                    </div>
                                    <Box sx={{display: 'flex', flexDirection: 'column', gap: '32px'}}>
                                        {values.questions.map((question, index) => (
                                            <Box key={index}
                                                 sx={{gap: '32px', background: '#F5F8FB', padding: '24px 28px', borderRadius: '8px'}}>
                                                <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
                                                    <div className='step-three-questions'>Вопрос {index + 1}</div>
                                                    <Box sx={{display: 'flex', gap: '8px'}}>
                                                        <button type="button" className="delete-button-step-three-task"
                                                                onClick={() => insert(index + 1, { ...values.questions[index] })}>
                                                            {copy}
                                                        </button>
                                                        <button type="button" className="delete-button-step-three-task"
                                                                onClick={() => setFieldValue(`questions[${index}].isLocked`, !question.isLocked)}>
                                                            {editTask}
                                                        </button>
                                                        <button type="button" className="delete-button-step-three-task"
                                                                onClick={() => remove(index)}>
                                                            {trash}
                                                        </button>
                                                    </Box>
                                                </Box>
                                                <Field
                                                    name={`questions[${index}].question`}
                                                    as={TextField}
                                                    variant="outlined"
                                                    placeholder="Введите вопрос"
                                                    className="without-label"
                                                    disabled={question.isLocked}/>
                                                <ErrorMessage name={`questions[${index}].question`} component="div" className="error-message" />
                                                <div className='step-three-answer'>Ответ</div>
                                                <Field name={`questions[${index}].answer`}
                                                       as={TextField}
                                                       variant="outlined"
                                                       placeholder="Введите ответ"
                                                       className="without-label"
                                                       multiline
                                                       disabled={question.isLocked}
                                                />
                                                <ErrorMessage name={`questions[${index}].answer`} component="div" className="error-message" />
                                                {!question.isLocked &&
                                                    <div className="parent-container">
                                                        <button className='add-button-step-three-task'
                                                        >
                                                            Добавить
                                                        </button>
                                                    </div>
                                                }
                                            </Box>
                                        ))}
                                    </Box>
                                    {typeof errors.questions === 'string' && touched.questions && (
                                        <div className="error-message">{errors.questions}</div>
                                    )}
                                  {values.questions.length < 12 && (
                                    <Button
                                      sx={{color: '#0573E4', fontSize: '14px', fontWeight: '600', marginTop: '32px', textTransform: 'none'}}
                                      className="add-field"
                                      onClick={() => push({question: '', answer: '', isLocked: false})}
                                      variant="text"><Add/>Добавить вопрос
                                    </Button>
                                  )}
                                </div>
                            )}
                        </FieldArray>
                        <div className="chapter-drawer-footer-Lacture">
                            <Button
                                variant="contained"
                                type="submit">

                                Сохранить
                            </Button>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default StepThreeTask;
